import CardsContainer from './CardsContainer';

export { type CardsContainerProps } from './CardsContainer';
export default CardsContainer;
